import React from 'react';
import i18next from 'i18next';

import Dialog from '~src/shared/dialogs/dialog/Dialog';
import SvgIcon from '~src/shared/SvgIcon';
import { KeyTextI } from '~src/interfaces/translate.interface';
import { txtOrKey } from '~src/utils';

import * as SC from './notificationDialog.sc';

interface Props {
  t: i18next.TFunction;
  show: boolean;
  close: boolean;
  title?: KeyTextI;
  descr?: KeyTextI;
  btnTxt?: KeyTextI;
  titleBarKey?: string;
  onHide(): void;
}

const NotificationDialog: React.FC<Props> = React.memo(
  ({
    t,
    title,
    descr,
    btnTxt = { key: 'x.scale.details.notification_modal.button_ok' },
    onHide,
    show,
    close,
    titleBarKey = 'x.warning',
  }) => (
    <Dialog show={show} close={close} title={t(titleBarKey)} headerColor="baseBlue" onHide={onHide}>
      <SC.ModalContent>
        <SvgIcon name="iconDanger" width={60} />
        {title && <SC.Title data-translation={title.key}>{title.txt}</SC.Title>}
        {descr && <SC.Description data-translation={descr.key}>{descr.txt}</SC.Description>}
        <SC.ButtonOk onClick={onHide}>
          <span data-translation={btnTxt.key}>{txtOrKey(btnTxt, t)}</span>
        </SC.ButtonOk>
      </SC.ModalContent>
    </Dialog>
  ),
);

export default NotificationDialog;
